<template lang="pug">
  VuePopper(:options="popperOptions")
    .popper {{ message }}
    img.img-fluid(slot="reference",src="../assets/img/question_mark.png",alt="More Info")
</template>

<script>
import VuePopper from 'vue-popperjs'
import 'vue-popperjs/dist/css/vue-popper.css'
export default {
  name: 'HelpPopover',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  data: function() {
    return {
      popperOptions: {
        placement: 'bottom-start',
        modifiers: {
          preventOverflow: {
            enabled: true,
          },
        },
      },
    }
  },
  components: {
    VuePopper,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';
.popper {
  @extend .body-3;
  padding: 0.3rem;
  width: 20rem;
  border: 1px solid #e6e6e6;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
img {
  width: 1.2rem;
}
</style>
